<template>
  <div>
    <v-select
      @change="handleSetKeyPicker"
      v-model="keyPicker"
      :rules="rules"
      :items="appointmentKeyPicker"
      :label="$t('appointment.formCreate.labels.keyPicker')"
      hide-details="auto"
      item-value="value"
      item-text="label"
      outlined
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { appointmentKeyPicker } from '../appointmentFormDefaults'

export default {
  name: 'KeyPicker',

  props: {
    rules: {
      type: Array,
    },
  },

  data() {
    return {
      keyPicker: null,
      appointmentKeyPicker,
    }
  },

  computed: {
    ...mapGetters(['appointmentFields']),
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    handleSetKeyPicker(value) {
      const { key_location_options } = this.appointmentFields

      this.setAppointmentFields({
        key_location_options: { ...key_location_options, key_picker: value },
      })
    },
  },

  mounted() {
    if (this.appointmentKeyPicker.length >= 1) {
      this.keyPicker = this.appointmentKeyPicker[0].value
      this.handleSetKeyPicker(this.appointmentKeyPicker[0].value)
    }
  },
}
</script>
